export const name =
`商品名称是为了管理方便而进行区分本商品的名称。<br><br>
也可以是销售名称`;

